import React from 'react'

interface BulkProcessingModuleOptions {
  id: string
  menuOptionTitle: React.ReactNode
  component: (props: {
    selectedRecords: unknown[]
    invoked: boolean
    onComplete: () => void
  }) => React.ReactNode
}

class BulkProcessingModule {
  private _id: string
  private _menuOptionTitle: React.ReactNode
  private _component: (props: {
    selectedRecords: unknown[]
    invoked: boolean
    onComplete: () => void
  }) => React.ReactNode

  constructor(options: BulkProcessingModuleOptions) {
    this._id = options.id
    this._menuOptionTitle = options.menuOptionTitle
    this._component = options.component
  }

  set id(id: string) {
    this._id = id
  }

  get id(): string {
    return this._id
  }

  set menuOptionTitle(title: React.ReactNode) {
    this._menuOptionTitle = title
  }

  get menuOptionTitle(): React.ReactNode {
    return this._menuOptionTitle
  }

  set component(
    component: (props: {
      selectedRecords: unknown[]
      invoked: boolean
      onComplete: () => void
    }) => React.ReactNode
  ) {
    this._component = component
  }

  get component(): (props: {
    selectedRecords: unknown[]
    invoked: boolean
    onComplete: () => void
  }) => React.ReactNode {
    return this._component
  }
}

export default BulkProcessingModule
